//用户信息处理

var bridge = require("./bridge")
var cookie = require("./cookie.js")


var user = {
	statusLogin:false,
	cbCheckLogin:null,		//检查登录后的回调
	nickname:"",
	uid:"",//用户uid
	ct:"",//用户ct
	ut:"",//用户ut
	hasEmitLoginCheck:false,		//区分IOS app和safari;

	isLogin:function(){
		return this.statusLogin;
	},

	checkLogin:function(cb){
		if(bridge.isHybrid()){
			this.cbCheckLogin = cb;
			bridge.eventGetLoginStatus("embedHelper.user.callbackGetLoginStatus");
		}else{
			var pi = cookie.get("pi")
			if(pi && pi != "null"){
				this.statusLogin=true;
			}
			if(cb){
				cb();
			}
		}
	},

	/*
	 * 定义回调
	 *
	 * 返回值'returnValue'为json串：{“code”:”0”,”data”:{“pi”:””,”ct”:””,”ut”:””},”msg”:””}
	 * code：获取成功状态，0=成功，非零=失败
	 * data：登陆成功后返回的登录验证串，内容为pi、ct、ut值
	 * msg： 调试时返回调试数据用，正式发包是返回空值
	 */
	callbackGetLoginStatus:function(returnValue) {
		var json = JSON.parse(returnValue);
		this.handleUserNativeLoginData(json);
	},

	//请求登录
	login:function(cb){
		if(bridge.isHybrid()){
			this.cbCheckLogin = cb;
			bridge.eventLogin("embedHelper.user.callbackLogin");
		}else{
			// if(window.location.href.indexOf("isinbrowser")<0){
			// 	window.location.href="https://emwap.eastmoney.com/user/Login?backurl="+encodeURIComponent(window.location.href);
			// }else{
			// 	window.location.href="https://emwap.eastmoney.com/user/Login?backurl="+encodeURIComponent(window.location.href);
			// }
		}
	},

	callbackLogin:function(returnValue){
		var json = JSON.parse(returnValue);
		this.handleUserNativeLoginData(json);
	},

	updateUserTokenByLost:function(){		//安卓机下分享微信cookie丢失bug
		var pi = cookie.get("pi")
		if(!pi){
			cookie.set("pi",(sessionStorage.getItem("pi")?sessionStorage.getItem("pi"):""),"d999999")
			cookie.set("ct",(sessionStorage.getItem("ct")?sessionStorage.getItem("ct"):""),"d999999")
			cookie.set("ut",(sessionStorage.getItem("ut")?sessionStorage.getItem("ut"):""),"d999999")
			this.nickname = sessionStorage.getItem("nickname")
			this.uid = sessionStorage.getItem("uid")
		}
	},

	handleUserNativeLoginData:function(json){
			if (json != null && json != "") {
					if (json.code != "0") {
						this.statusLogin=false;
						cookie.set("pi","","1s")
						cookie.set("ct","","1s")
						cookie.set("ut","","1s")
						this.uid = 0
					}else {
						this.statusLogin=true;
						var data = json.data;
						cookie.set("pi",data.pi,"d999999")
						cookie.set("ct",data.ct,"d999999")
						cookie.set("ut",data.ut,"d999999")
						this.nickname = data.nickname;
						this.uid = data.uid;
						this.ct = data.ct;
						this.ut = data.ut;
						if(bridge.isAndroid()){
							sessionStorage.setItem("pi",data.pi)
							sessionStorage.setItem("ct",data.ct)
							sessionStorage.setItem("ut",data.ut)
							sessionStorage.setItem("nickname",data.nickname);
							cookie.set("nickname",data.nickname);
							sessionStorage.setItem("uid",data.uid)
						}
						// helper.observer.trigger("onAppLoginSuccess");
							//已登录处理，str.data中获取pi、ct、ut;
					}
			}else {
				this.statusLogin=false;
				alert("callbackGetLoginStatus登录异常")
				//异常做未登录处理
			}
			var oldCall = this.cbCheckLogin
			this.cbCheckLogin=null;
			if(oldCall){
				oldCall();
			}
	},
}

module.exports = user



//////////////////
// WEBPACK FOOTER
// ./src/module/helper/user.js
// module id = 9
// module chunks = 0